import { Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'
import {
  ResultTypeGroupTitle,
  SearchResultItem,
  SearchResultItemDescription,
  SearchResultItemText,
} from '../../../styled'

const Wrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`
const Content = styled(Flex)`
  display: flex;
  padding-left: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

interface ResultTypeGroupProps {
  title: string
  items: any[]
}
const ResultTypeGroup = ({ title, items }: ResultTypeGroupProps) => {
  return (
    <Wrapper>
      <ResultTypeGroupTitle>{title}</ResultTypeGroupTitle>
      <Content>
        {items.map((item) => {
          const Icon = item.icon
          return (
            <SearchResultItem key={item.description}>
              <Icon />
              <SearchResultItemText>{item.text}</SearchResultItemText>
              <SearchResultItemDescription>{item.description}</SearchResultItemDescription>
            </SearchResultItem>
          )
        })}
      </Content>
    </Wrapper>
  )
}

export default ResultTypeGroup
